import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { StorageService } from './../../providers/storage.service';
import { HttpService } from './../../providers/http.service';
import { LotteryModel } from './../../models/lottery.model';


@Component({
	selector: 'page-lottery-all',
	templateUrl: 'lottery-all.html',
})
export class LotteryAllPage {

	lotterys: LotteryModel[] = [];
	likes: LotteryModel[] = [];
	leaves: LotteryModel[] = [];
	constructor(
		public navParams: NavParams,
		public ViewCtrl: ViewController,
		public http: HttpService,
		public storage: StorageService
	) { }

	//初始页面
	//chen 2017-01-11
	//TQQ update 2018-01-25
	ionViewDidLoad() {
		this.lotterys = this.navParams.get('lotterys');
		this.likes = this.navParams.get('likes');
		this.getLeave();
	}


	//获取剩余彩种
	//chen 2017-01-13
	getLeave() {
		this.leaves = [];
		if (this.likes == null || this.likes.length == 0) {
			this.leaves = this.lotterys;
		} else {
			for (var i = 0; i < this.lotterys.length; i++) {
				var id = this.lotterys[i].ID;
				if (this.likes.find(s => s.ID == id) == undefined) {
					this.leaves.push(this.lotterys[i]);
				}
			}
		}
	}

	//添加彩种
	addition(obj) {
		this.likes.push(obj);
		this.getLeave();
	}

	//删减彩种
	subtraction(obj) {
		var idx = this.likes.findIndex(s => s.ID == obj.ID);
		this.likes.splice(idx, 1);
		this.getLeave();
	}

	//页面关闭，存储彩种
	//update  chen 2017-05-26
	dismiss() {
		if (this.likes.length > 0) {
			this.ViewCtrl.dismiss(this.likes);

		} else {
			this.ViewCtrl.dismiss(this.lotterys);
		}
		this.storage.write('likes', this.likes);

	}

	//返回主界面
	//chen 2017-02-14
	goBack() {
		if (this.likes.length > 0) {
			this.ViewCtrl.dismiss(this.likes);
		} else {
			this.ViewCtrl.dismiss(this.lotterys);
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/lottery-all/lottery-all.ts